module.exports=function(scope){ return `curl -X GET \
  'https://api.zoomauth.com/api/v2/biometrics/session-token' \
  -H 'X-Device-License-Key: ${scope.appToken}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/bash/session-token.bash.tpl